import './free_text_user_profile_attribute_view.js.coffee'

class Customer.IntegerUserProfileAttributeView extends Customer.FreeTextUserProfileAttributeView
  inputType: 'number'

  afterRender: ->

  # No estaba claro para qué se redefinía, pero terminaba siempre borrando todos los integer attributes
  # getDeleted: ->
  #   deleted = super
  #   @$el.find('input').each (_, input) ->
  #     deleted.values.push $(input).val() unless $(input).is(':valid')
  #   deleted
